import React from 'react';
import { getQrLanderTarget } from '../lib/firestore';

const DEFAULT_TARGET_URL = 'https://www.youtube.com/watch?v=dQw4w9WgXcQ';

function normalizeTargetUrl(value: string | null) {
  const raw = (value || DEFAULT_TARGET_URL).trim();
  try {
    const url = new URL(raw);
    if (url.protocol === 'https:' || url.protocol === 'http:') return url.toString();
  } catch {
    // Fall back below.
  }
  return DEFAULT_TARGET_URL;
}

export default function QrLanderPage() {
  const [targetUrl, setTargetUrl] = React.useState(DEFAULT_TARGET_URL);
  const [failed, setFailed] = React.useState(false);

  React.useEffect(() => {
    let active = true;

    getQrLanderTarget()
      .then((nextTargetUrl) => {
        if (!active) return;
        const next = normalizeTargetUrl(nextTargetUrl);
        setTargetUrl(next);
        window.location.replace(next);
      })
      .catch(() => {
        if (!active) return;
        window.location.replace(DEFAULT_TARGET_URL);
      });

    const timer = window.setTimeout(() => {
      if (active) setFailed(true);
    }, 3000);

    return () => {
      active = false;
      window.clearTimeout(timer);
    };
  }, []);

  return (
    <main className="flex min-h-screen items-center justify-center bg-zinc-50 p-4">
      <div className="w-full max-w-sm rounded-2xl border border-zinc-200 bg-white p-5 text-center shadow-sm">
        <div className="text-sm font-semibold text-zinc-900">Redirecting</div>
        <div className="mt-1 text-sm text-zinc-600">Taking you to the linked content.</div>
        {failed ? (
          <a className="mt-4 inline-flex text-sm font-semibold text-accent" href={targetUrl}>
            Continue
          </a>
        ) : null}
      </div>
    </main>
  );
}
